module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/step/style2/style2.component.scss
// module id = ./src/app/features/step/style2/style2.component.scss
// module chunks = main